import { Tooltip } from '@ksyos/design-system';
import type { ICheckedTreatment } from '@common/interfaces/checkedTreatment';
import type { TherapielandTreatmentCategory } from '../../../../../../common/enums/therapielandTreatmentCategory';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';

interface ITreatmentListProps {
    category: TherapielandTreatmentCategory;
    checkedTreatments: ICheckedTreatment[];
    label: string;
}

export function TreatmentList({ label, category, checkedTreatments }: ITreatmentListProps): JSX.Element {
    if (getTreatmentsForCategory(checkedTreatments, category).length < 1) {
        return <></>;
    }

    return (
        <HorizontalFormGroupRead>
            <FormLabel>{label}</FormLabel>
            <InputContainer>
                {getTreatmentsForCategory(checkedTreatments, category).map((checkedTreatment: ICheckedTreatment) => {
                    return (
                        <div key={checkedTreatment.id}>
                            <Tooltip
                                content={`ID ${checkedTreatment.id}`}
                                hasArrow={false}
                                placement="right"
                            >
                                <span style={{ fontWeight: 900 }}>{checkedTreatment.treatmentName}</span>
                            </Tooltip>
                        </div>
                    );
                })}
            </InputContainer>
        </HorizontalFormGroupRead>
    );
}

export function getTreatmentsForCategory(
    checkedTreatments: ICheckedTreatment[],
    category: TherapielandTreatmentCategory
) {
    return checkedTreatments.filter((checkedTreatment: ICheckedTreatment) => checkedTreatment.category === category);
}
